import type { AxiosError } from 'axios';

const NOTIFY_USER_PREFIX = 'Notify User:';

/**
 * Extracts the user-facing message from a backend 'Notify User:'-prefixed error response.
 * Returns null when the error carries no such message (unexpected errors, network failures).
 */
export const getNotifyUserMessage = (error: unknown): string | null => {
  const message = (error as AxiosError<{ message?: string }>)?.response?.data?.message;
  if (typeof message === 'string' && message.startsWith(NOTIFY_USER_PREFIX)) {
    return message.replace(NOTIFY_USER_PREFIX, '').trim();
  }
  return null;
};
